import * as React from 'react'
import { Icon, Popover } from 'antd'
import { RouteComponentProps } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Link } from 'util/utils'
import styles from './index.scss'

interface UserCenterButtonProps extends RouteComponentProps<any> {
  style?: React.CSSProperties
  userStore?: IUserStore.UserStore
  loginStore?: ILoginStore.LoginStore
  globalStore?: any
}

@inject('loginStore', 'globalStore')
@observer
class UserCenterButton extends React.Component<UserCenterButtonProps> {
  handleClick() {
    const { location, history } = this.props
    if (location.pathname === '/usercenter') {
      return
    }
    history.push('/usercenter')
  }
  render() {
    const {
      globalStore: { menus },
    } = this.props

    const content = list => (
      <div className={styles.popMenu}>
        <ul>
          {list.map((item, idx) => {
            return item.logout ? (
              <li
                key={idx}
                style={{ cursor: 'pointer' }}
                onClick={() => this.props.loginStore.logout()}
              >
                {item.name}
              </li>
            ) : (
              <li key={idx}>
                <Link to={item.url}>{item.name}</Link>
              </li>
            )
          })}
        </ul>
      </div>
    )

    const { userInfo } = this.props.userStore
    return (
      <Popover
        overlayClassName="user-center-popover"
        content={content(menus)}
        trigger="hover"
        arrowPointAtCenter
      >
        <div>
          <img
            style={{
              display: 'block',
              width: 36,
              height: 36,
              margin: '0 auto',
              borderRadius: '50%',
              backgroundColor: '#ccc',
            }}
            src={userInfo.img_url}
            alt=""
          />
          <span
            onClick={() => this.handleClick()}
            className={styles.userCenterButton}
          >
            <span style={{ fontSize: 14, color: '#333' }}>
              {userInfo.staff_name}
            </span>
          </span>
        </div>
      </Popover>
    )
  }
}

export default UserCenterButton
